export const loginStyles = {
  container: "flex h-screen w-full bg-white font-sans overflow-hidden",
  formWrapper: "w-full lg:w-1/2 flex flex-col justify-center items-center px-10 md:px-20",

  headerWrapper: "mb-2 flex flex-col items-center lg:items-start w-full",
  logo: "h-160 w-auto mb-2 object-contain", 
  title: "text-[28px] font-bold text-msc-green italic leading-tight text-center lg:text-left",
  
  inputField: "w-full px-4 py-4 rounded border border-blue-200 bg-[#ebf3ff] focus:ring-2 focus:ring-msc-blue outline-none transition-all text-gray-700 placeholder:text-gray-400",
  label: "text-[11px] font-black text-black uppercase tracking-tight mb-1 block",
  primaryButton: "bg-[#0f1115] text-white px-10 py-3 rounded shadow-md font-bold uppercase text-xs tracking-widest hover:bg-black transition-all active:scale-95 disabled:opacity-50",
  secondaryLink: "text-[13px] text-gray-500 hover:text-msc-blue underline underline-offset-4 decoration-gray-400 transition-colors",
  
  imageSection: "hidden lg:block lg:w-1/2 relative h-full",
  heroImage: "h-full w-full object-cover",
};